import { render, staticRenderFns } from "./RegistrationLink.vue?vue&type=template&id=9609da30&scoped=true&"
import script from "./RegistrationLink.vue?vue&type=script&lang=js&"
export * from "./RegistrationLink.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationLink.vue?vue&type=style&index=0&id=9609da30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9609da30",
  null
  
)

export default component.exports